const brochure = {
    getlist: 'brochure/getlist-by-admin',
    add: 'brochure/add',
    update: 'brochure/update',
    remove: 'brochure/remove',
    get: 'brochure/get',
    getall: 'brochure/getall',
}
export default brochure
